module.exports = __webpack_public_path__ + "img/call.4ccb1d0e.png";